export const labels = {
	title: {
		label: "Label.MobileCreator.PhotoSourceDialog.Title",
		default: "Use photos from",
	},
	photoPickerFailed: {
		label: "Label.MobileCreator.PhotoSourceDialog.SelectFailed",
		default: "Error selecting photos",
	},
	externalPickerConnected: {
		label: "Label.MobileCreator.PhotoSourceDialog.Connected",
		default: `Connected to {0}. You can now click the button to select photos`,
	},
	connectedAs: {
		label: "Label.MobileCreator.PhotoSource.ConnectedAs",
		default: "Connected as {0}",

		// description: "Eg. 'Connected as Mark Zuckerberg'",
		// 0: "User name for which the user is connected with the photo source (eg. Facebook, Instagram, ...)",
	},
	numberOfEmptyPhotoZones: {
		label: "Label.MobileCreator.PhotoSource.NmbrEmptyPhotoZones",
		default: "Your product contains {0} empty photo zone(s).",
		// description: "Your product contains {0} empty photo zone(s)."
	},
} as const;
